import React, { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import helpCircleIcon from "../../assets/images/help-circle.png";
import { ClickAwayListener } from "@mui/material";
import Button from "@mui/material/Button";

import "./HelpCircleIcon.scss";

const HelpCircleIcon = (props: { label?: string, title?: string }) => {
  const [open, setOpen] = useState<boolean>(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  return (
    <>
      {/* TODO -AA ref */}
      <div className="desktop">
        <Tooltip
          tabIndex={-1}
          arrow
          title={props.label &&  props.label !== 'noLabel' ? props.label : ""}
          placement="top-start"
          role="img"
        >
          <Button style={{ minWidth: "initial",cursor:"default" }}    component="span">
          {props.label === 'noLabel'? <img
              src={helpCircleIcon}
              style={{visibility:"hidden" }}/> : <img
              src={helpCircleIcon}
              alt="help"
              style={{ cursor: "pointer" }}
              title="מידע נוסף"
            />}
          </Button>
        </Tooltip>
      </div>

      <div className="mobile">
        <ClickAwayListener onClickAway={handleTooltipClose}>
          <Tooltip
            tabIndex={-1}
            onClose={handleTooltipClose}
            open={open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            arrow
            title={props.label ? props.label : ""}
            placement="top-start"
          >
            <img
              src={helpCircleIcon}
              alt="help"
              style={{ cursor: "pointer" }}
              onClick={handleTooltipOpen}
            />
          </Tooltip>
        </ClickAwayListener>
      </div>
    </>
  );
};

export default HelpCircleIcon;
